import React from 'react';
import { CheckIcon } from 'lucide-react';
const capabilities = ['Single-page applications (React, Vue, Angular)', 'RESTful and GraphQL APIs', 'Real-time features and WebSocket integration', 'Authentication and authorization systems', 'Payment processing and e-commerce', 'Progressive web apps (PWAs)'];
export function Capabilities() {
  return <section className="py-16" data-id="element-594">
      <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-595">
        <div className="scroll-fade-in-up" data-id="element-596">
          <div className="bg-surface rounded-xl p-8 md:p-12" data-id="element-597">
            <h2 className="text-2xl font-bold text-ink mb-4" data-id="element-598">
              Key Capabilities
            </h2>
            <p className="text-gray-600 mb-8 leading-relaxed" data-id="element-599">
              Our full-stack web development team builds scalable, secure, and
              high-performance applications tailored to your business needs.
              From modern single-page applications to robust backend
              architectures and cloud integrations, we deliver comprehensive
              solutions that drive growth and efficiency.
            </p>
            <ul className="grid grid-cols-1 md:grid-cols-2 gap-4" data-id="element-600">
              {capabilities.map((cap, i) => <li key={i} className="flex items-start" data-id="element-601">
                  <CheckIcon className="w-5 h-5 text-primary mr-3 mt-0.5 flex-shrink-0" data-id="element-602" />
                  <span className="text-gray-700" data-id="element-603">{cap}</span>
                </li>)}
            </ul>
          </div>
        </div>
      </div>
    </section>;
}